import { gql } from "apollo-angular";

export const GET_STOREFRONT_CONSOLIDATED_FEED = gql`
    query GetStorefrontConsolidatedFeed {
        storefrontConsolidatedFeed {
            id
            name
            customerMov
            pricingIds
            liveUrls {
                csv
                xlsx
                xml
            }
        }
    }
`;

export const SET_CONSOLIDATED_FEED_ORDER = gql`
    mutation SetConsolidatedFeedOrder($consolidated: Boolean!) {
        setConsolidatedFeedOrder(consolidated: $consolidated)
    }
`;
